import { useLocation } from "react-router-dom";

const useLocationHook = () => {
  const { pathname } = useLocation();

  return {
    isLivePage: pathname.includes("/orders/live"),
    isPosOrderPage: pathname.includes("/orders/pos-order"),
    isWaiterPage: pathname.includes("/waiter"),
    isOrderDetailPage: pathname.includes("/order/"),
    isUsersPage: pathname.includes("/users"),
    isUserDetailPage:
      !pathname.includes("/users") && pathname.includes("/user"),
    isUserOrdersPage:
      pathname.includes("/user/") && pathname.includes("/orders"),
    isVersionDetailPage: pathname.includes("/version/"),
    isReceiptDetailPage: pathname.includes("/receipt/"),
    isReviewDetailPage: pathname.includes("/review/"),
    isPushDetailPage: pathname.includes("/marketing/push/"),
    isNewsletterDetailPage: pathname.includes("/marketing/newsletter/"),
    isDiscountDetailPage: pathname.includes("/korting/"),
    isWebsiteSettingsDetail: pathname.includes("/websitesettings/"),
    isZipcodeDetail: pathname.includes("/zipcodes/"),
    isTermsCondition: pathname.includes("/terms"),
    isLoyaltyEditPage: pathname.includes("/loyalty/edit"),
    isSessionOrderPage: pathname.includes("/session-orders/"),
  };
};

export default useLocationHook;
